import React, { Component } from 'react';
import { Column, cls, Heading } from '../../../packages/components';

class ChannelEventInfo extends Component {
  constructor(props = {}) {
    super(props);
    this.channelData = this.props && this.props.channelData ?  this.props.channelData : {};
  }

  render() {
    return (
      <Column lg={12} className={cls(`aaf-main-modal-channel-info`)}>
        <Column
          lg={2}
          className={cls(`aaf-main-modal-channel aaf-main-modal-channel-number`)}>
          {this.channelData && this.channelData.channel_number && (
            <Heading size={1} className={cls(`aaf-main-modal-channel-number-h`)}>
              {this.channelData.channel_number}
            </Heading>
          )}
        </Column>
        <Column
          lg={10}
          className={cls(`aaf-main-modal-channel aaf-main-modal-channel-column-img`)}>
          {this.channelData && this.channelData.imageEpg && (
            <img
              src={this.channelData.imageEpg}
              className={cls(`aaf-main-modal-channel-img`)}
            />
          )}
        </Column>
      </Column>
    );
  }
}

export default ChannelEventInfo;



// WEBPACK FOOTER //
// ./src/components/EventOptions/components/ChannelEventInfo.jsx